import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { DiscountMethod } from "../discount-models/DiscountMethod";
import { FormGroup } from "@angular/forms";
import { newDiscountFormQuestionsContent } from "./new-discount-form-questions/new-discount-form-questions";
import { GenericFormComponent } from "../../../form/generic-form/generic-form.component";
import { DiscountManagementService } from "../../../_services/discount-management.service";

@Component({
  selector: "new-discount-form-select-price",
  templateUrl: "./new-discount-form-select-price.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "../new-discount-form-select-event-parent/new-discount-form-select-event-parent.component.scss",
    "./new-discount-form-select-price.component.scss",
  ],
})
export class NewDiscountFormSelectPriceComponent implements OnInit, OnDestroy {
  @Input("newDiscountFormState")
  public newDiscountFormState$: Observable<NewDiscountFormState>;
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<NewDiscountFormState> = new EventEmitter<NewDiscountFormState>();
  public translations$: Observable<ITranslations>;
  public readonly DiscountMethod = DiscountMethod;
  public discountMethod: DiscountMethod = DiscountMethod.Number;
  public formQuestions = newDiscountFormQuestionsContent;
  public additionalDiscountDetailsForm: FormGroup =
    GenericFormComponent.buildFormGroup(this.formQuestions);
  public shekelDiscount: any;
  public percentDiscount: any;
  public numberOfSelectedChildEvents: number = 0;
  private currentFormState: NewDiscountFormState;

  constructor(
    protected translationService: TranslationService,
    private discountManagementService: DiscountManagementService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.newDiscountFormState$.subscribe((state) => {
      this.currentFormState = state;
      this.numberOfSelectedChildEvents =
        state.event && state.event.childEvents
          ? state.event.childEvents.filter((x) => x.isSelected).length
          : 0;
    });

    this.additionalDiscountDetailsForm.valueChanges.subscribe((value) => {
      this.updateDiscountEvent.emit({
        ...this.currentFormState,
        discountDetails: {
          comments: value.comments,
          numberOfPayments:
            (value.numberOfPayments && value.numberOfPayments.key) || 1,
          passedCommittee: !!value.passedCommittee,
        },
      });
    });
    // this.additionalDiscountDetailsForm.patchValue({
    //   numberOfPayments: discountPaymentOptions[0],
    // });
  }

  public calculatePriceAfterDiscount(price: number) {
    return this.discountManagementService.calculatePriceAfterDiscountFromFormPage(
      price,
      this.discountMethod,
      this.shekelDiscount,
      this.percentDiscount
    );
  }

  public ngOnDestroy(): void {}

  public clickedPaymentMethod($event: MouseEvent) {
    if ($event) {
      $event.preventDefault();
    }
    this.discountMethod =
      this.discountMethod === DiscountMethod.Number
        ? DiscountMethod.Percentage
        : DiscountMethod.Number;
    this.updateFormState();
  }

  public discountInputBlurEvent($event: FocusEvent) {
    if ($event) {
      $event.preventDefault();
    }
    this.updateFormState();
  }
  public updateFormState() {
    this.updateDiscountEvent.emit({
      ...this.currentFormState,
      amount: {
        type: this.discountMethod,
        value:
          this.discountMethod === DiscountMethod.Number
            ? this.shekelDiscount
            : this.percentDiscount,
      },
    });
  }
  public formChangeEventHandler($event: any) {
    setTimeout(() => {
      this.updateFormState();
    }, 50);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-select-price/new-discount-form-select-price.component.ts